import { applyScssStyles, getRegionalConfig } from './get-regional-config';
import { ApplyStyleConfig } from './regional-config-types';

export const config = getRegionalConfig();

export { getRegionalConfig } from './get-regional-config';

applyScssStyles(config.scssStyles || ({} as ApplyStyleConfig));
